/**
 * Analytics Module
 *
 * Provides analytics tracking for the purchase flow.
 * Types are defined in types/analytics.ts for centralized type management.
 */

// Re-export types from types folder (canonical source)
export type {
  AnalyticsEventName,
  AnalyticsConfig,
  EventProperties,
  OnAnalyticsEvent,
  AnalyticsContextValue as UsePurchaseAnalyticsResult
} from '../types/analytics';

// Export provider and hook
export { AnalyticsProvider, usePurchaseAnalytics } from './PurchaseFlowAnalytics';
